export class RouteSchedule {
  id: number;
  lap: number;
  time: string;
  date: string;
  timeShort: string;
  dateTimeLong: string;
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/route-schedule.ts